import { faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Form, Pagination, ProgressBar, Row, Spinner, Table } from 'react-bootstrap'
import toast from 'react-hot-toast';
import Select from "react-select"
import { UsersCard } from '../../component/Card/Statistics.card';
import { ClientService } from '../../component/services/client.service';
import CsrReportTable from '../../component/table/CsrReportTable';
import downloadjs from 'downloadjs';
import { faBuilding, faCheckCircle, faFilter, faRefresh, faSpinner } from '@fortawesome/free-solid-svg-icons';
import UserModal from '../../component/modals/User.modal';
import { FaRegEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { saveAsCSV } from '../../component/helpers/csvhelper';
import moment from 'moment';
import CetLoader from '../../component/Loader/CetLoader';
import { AgCharts } from 'ag-charts-react';
import TablePaginationComponent from '../../component/table/TablePagination';
import FiltersComponent, { FilterOption } from '../../component/Filters/FiltersComponent';
import StatsCardWithProgress from '../../component/Cards/StatsCardWithProgress';
import StatsCard from '../../component/Cards/StatsCard';

export default function AttendanceStats() {

    const navigate = useNavigate();


    const [selectValue, setSelectValue] = useState<any>();
    const [shifts, setShifts] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [centerData, setCenterData] = useState<any>([])

    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<any>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [bioStartCount, setBioStartCount] = useState<number>(0);

    const [selectedFilters, setSelectedFilters] = useState<{
        states: FilterOption[];
        zones: FilterOption[];
        districts: FilterOption[];
        centers: FilterOption[];
    }>({
        states: [],
        zones: [],
        districts: [],
        centers: [],
    });

    const handleFiltersChange = (filters: any) => {
        setSelectedFilters(filters);
    };


    const getAllShift = async () => {
        await ClientService.getAllShifts().then(res => {
            if (res.status === 200) {
                setShifts(res.data.shifts.map((data: any) => {
                    return {
                        label: data.shiftName + " - " + moment(data.startTime).format("DD MMM YYYY"),
                        value: data._id
                    }
                }))
            }
        }).catch(err => {
            toast.error(err.response.data);
        })
    }

    const getData = async () => {
        if (!selectValue) {
            toast.error("Please select a shift");
            return;
        }
        let payload = {};
        if (selectedFilters?.centers?.length > 0) {
            payload = { ...payload, centerId: selectedFilters?.centers?.map((center: any) => center.value) }
        }
        if (selectedFilters?.states?.length > 0) {
            payload = { ...payload, state: selectedFilters?.states?.map((state: any) => state.value) }
        }
        if (selectedFilters?.districts?.length > 0) {
            payload = { ...payload, city: selectedFilters?.districts?.map((district: any) => district.value) }
        }
        if (selectedFilters?.zones?.length > 0) {
            payload = { ...payload, zone: selectedFilters?.zones?.map((zone: any) => zone.value) }
        }

        setLoading(true);

        await ClientService.getAttendanceStats(selectValue, pageNumber, pageSize, payload)
            .then((res: any) => {
                if (res.status === 200) {
                    setCenterData(res.data?.data?.centerData || []);
                    setTotalCount(res.data?.data?.totalCenters || 0);
                }
            })
            .catch((err: any) => {
                toast.error(err.response.data);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getAllShift();
    }, [])

    useEffect(() => {
        if (selectValue) {
            getData();
        }
    }, [pageNumber, pageSize, selectedFilters])

    return (
        <>
            <Row className="mt-5 text-left">
                <Col md={8}>
                    <h4 className="text-secondary mt-3 fw-bold">Attendance Stats</h4>
                </Col>
                <Col md={4}>
                    <Form.Label className="text-muted fw-bold">
                        Select Shift
                    </Form.Label>
                    <Select
                        options={shifts}
                        placeholder="Select Shifts"
                        onChange={(e: any) => setSelectValue(e?.value)}
                        isClearable
                        value={selectValue ? shifts.find((shift: any) => shift.value === selectValue.value) : null}
                    />
                </Col>
            </Row>

            <FiltersComponent
                selectedShift={selectValue}
                onFiltersChange={handleFiltersChange}
            />


            {loading ? <CetLoader /> :
                <Row>
                    <Col>
                        <Card
                            className="mt-3"
                            style={{
                                backgroundColor: "#f9f9f9",
                                borderRadius: "12px",
                                border: "none",
                            }}
                        >
                            <Card.Body>

                                <Row className='mt-2'>
                                    <div className="d-flex align-items-center justify-content-end">
                                        <Button size="sm" onClick={getData} variant="outline-secondary" className='d-flex align-items-center gap-1'>
                                            <FontAwesomeIcon icon={faRefresh} /> Reload
                                        </Button>
                                    </div>
                                </Row>
                                <Row className='mt-2'>
                                    <Col md={3}>
                                        <Col md={12} className="mb-3">
                                            <StatsCard
                                                title="Total Centers"
                                                value={totalCount}
                                                icon={faBuilding}
                                                iconColor="success"
                                                valueColor="success"
                                            />
                                        </Col>
                                    </Col>
                                </Row>
                                <Table striped hover responsive className='mt-3'>
                                    <thead>
                                        <tr>
                                            <th style={{ fontSize: 14 }}>Sr. No</th>
                                            <th style={{ fontSize: 14 }}>Venue ID</th>
                                            <th style={{ fontSize: 14 }}>Venue Name</th>
                                            <th style={{ fontSize: 14 }}>State</th>
                                            <th style={{ fontSize: 14 }}>Division</th>
                                            <th style={{ fontSize: 14 }}>City</th>
                                            <th style={{ fontSize: 14 }}>Present/Scheduled Candidates</th>
                                            <th style={{ fontSize: 14 }}>Present (%)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            loading ? (
                                                <tr>
                                                    <td colSpan={10} className="text-center">
                                                        <Spinner animation="border" />
                                                    </td>
                                                </tr>
                                            ) : centerData && centerData?.length > 0
                                                ?
                                                centerData?.map((data: any, index: any) => {
                                                    const progressVariant = data?.verificationPercentage >= 90 ? 'success' :
                                                        data?.verificationPercentage >= 75 ? 'warning' : 'danger';
                                                    return (
                                                        <tr>
                                                            <td>{index + 1}</td>
                                                            <td >{data?.centerPreference}</td>
                                                            <td >{data?.allocatedCenterId}</td>
                                                            <td >{data?.zone}</td>
                                                            <td >{data?.state}</td>
                                                            <td >{data?.city}</td>
                                                            <td >{data?.uniqueVerifiedUsers}/{data?.totalUsers}</td>
                                                            <td style={{ width: '300px' }}>
                                                                <div className="d-flex align-items-center">
                                                                    <div className="flex-grow-1 me-3">
                                                                        <ProgressBar
                                                                            now={data?.verificationPercentage}
                                                                            variant={progressVariant}
                                                                            style={{ height: '8px' }}
                                                                        />
                                                                    </div>
                                                                    <span
                                                                        className={`fw-bold text-${progressVariant}`}
                                                                        style={{ fontSize: '14px', minWidth: '45px' }}
                                                                    >
                                                                        {data?.verificationPercentage}%
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                                : (
                                                    <tr>
                                                        <td colSpan={10} className="text-center">
                                                            No Data Available
                                                        </td>
                                                    </tr>
                                                )
                                        }
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Row className='mt-2'>
                        <Col>
                            <TablePaginationComponent
                                currentPage={pageNumber}
                                itemsCount={totalCount}
                                itemsPerPage={pageSize}
                                setItemsPerPage={(e: any) => setPageSize(e)}
                                setCurrentPage={setPageNumber}
                            />
                        </Col>
                    </Row>
                </Row>
            }
        </>
    )
}